import React from 'react'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'


const HeadLineSlot = ({ ...props }) =>
  <HeadSlot>
    <Tagline>Your Tires. Your Way.</Tagline>
    <BriefInstructions>
      <ArrowIcon asset="arrow-right-white" alt="Arrow" height={ 19 } width={ 9 } />
      <TextWrapper>Tell Us What You Drive.</TextWrapper>
      <ArrowIcon asset="arrow-right-white" alt="Arrow" height={ 19 } width={ 9 } />
      <TextWrapper>Find Your New Tires.</TextWrapper>
      <ArrowIcon asset="arrow-right-white" alt="Arrow" height={ 19 } width={ 9 } />
      <TextWrapper>Choose An Installer.</TextWrapper>
    </BriefInstructions>
    <ShopBlock>Shop block</ShopBlock>
    <Discover>
      <VideoIcon asset="video" alt="Shape" height={ 58 } width={ 58 } />
      <Text>Discover the Tire America Advantage</Text>
    </Discover>
  </HeadSlot>

export default HeadLineSlot

const Tagline = styled.h2`
  display: block;
  padding-top: 72px;
  padding-bottom: 40px;
  color: ${Theme.colors.white};
  text-align: center;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(75)}
`

const BriefInstructions = styled.div`
  text-align: center;
`

const ShopBlock = styled.div`
  margin: 50px;
  color: ${Theme.colors.white};
  text-align: center;
`

const Discover = styled.div`
  margin: 80px 0;
  text-align: center;
`

const HeadSlot = styled.div`
  width: 1280px;
  margin: 0 auto;
`

const ArrowIcon = styled(Icon)`
  display: inline-block;
`

const VideoIcon = styled(Icon)`
  display: inline-block;
`

const TextWrapper = styled.span`
  display: inline-block;
  width: 120px;
  color: ${Theme.colors.white};
  vertical-align: middle;
  ${Mixin.font.GothamBold(18)}
`

const Text = styled.span`
  display: inline-block;
  padding-left: 5px;
  font-size: 24px;
  color: ${Theme.colors.white};
  vertical-align: middle;
`
